// src/components/FormSections/FormSectionAcademico.js

import React, { useEffect, useState, useRef } from "react"
import { useDispatch } from "react-redux"
import { Col, Row, CardBody, Card } from "reactstrap"
import FormikInput from "../Common/Formik/FormikInput"
import FormikDatePicker from "../Common/Formik/FormikDatePicker"
import FormikSelect from "../Common/Formik/FormikSelect"

// #region selectors
import {
  useCargosCostoInscripcion,
  useCargosCostoColegiatura,
  useControlEscolarDescuentosInscripcion,
  useControlEscolarDescInscOptions_Inscripcion,
  useControlEscolarDescInscOptions_Colegiatura,
  useCampusVirtualConfiguracion_xNombre,
} from "store/selectors"
// #endregion

// #region actions
import { getControlEscolarDescuentosInscripcion } from "../../store/actions"
// #endregion

// #region Descuentos personalizados
const optionsFrecuenciaColegiatura = [{ label: "Mensual", value: 1 }]
//
// #endregion

const FormSectionCargos = ({
  formik,
  handleUpperCaseChange,
  handleLowerCaseChange,
}) => {
  //
  // #region react-redux
  const dispatch = useDispatch()
  // #endregion

  const optionsPromociones = []
  const idFrecuencia = formik.values["id_Frecuencia"]

  // #region const-selectors

  const costoInscripcion = useCargosCostoInscripcion()
  const costoColegiatura = useCargosCostoColegiatura()
  const descuentosInscripcion = useControlEscolarDescuentosInscripcion()
  const optionsDescuentosInscripciones =
    useControlEscolarDescInscOptions_Inscripcion(true)
  const optionsDescuentosColegiatura =
    useControlEscolarDescInscOptions_Colegiatura(true)
  const id_Descuento_Inscripcion_Personalizada =
    useCampusVirtualConfiguracion_xNombre(
      "Descuentos_id_Descuento_Inscripcion_Personalizada"
    )
  const id_Descuento_Colegiatura_Personalizada =
    useCampusVirtualConfiguracion_xNombre(
      "Descuentos_id_Descuento_Colegiatura_Personalizada"
    )
  // #endregion

  // #region Internal States
  const [importeInscripcion, setImporteInscripcion] = useState(0)
  const [importeColegiatura, setImporteColegiatura] = useState(0)

  const [inputInscripcionDisabled, setInputInscripcionDisabled] = useState(true)
  const [inputColegiaturaDisabled, setInputColegiaturaDisabled] = useState(true)

  // #endregion

  // #region useEffects
  //
  // useEffect(() => {
  //   if (idFrecuencia > 0) {
  //     const foundOption = optionsFrecuenciaColegiatura.find(
  //       op => op.value === idFrecuencia
  //     )
  //     formik.setFieldValue("Frecuencia", foundOption?.label || "No encontrado")
  //   }
  // }, [idFrecuencia, formik])

  useEffect(() => {
    //console.log("descuentosInscripcion.length: ", descuentosInscripcion.length)
    if (descuentosInscripcion.length === 0) {
      dispatch(
        getControlEscolarDescuentosInscripcion({
          nombreSolicitud: "descuentosinscripcion",
        })
      )
      //
      setImporteInscripcion(0)
      setImporteColegiatura(0)
      //
      setInputInscripcionDisabled(true)
      setInputColegiaturaDisabled(true)
    }
  }, [descuentosInscripcion.length, dispatch])

  // Costo Inscripcion
  useEffect(() => {
    setImporteInscripcion(
      costoInscripcion && costoInscripcion.hasOwnProperty("Costo")
        ? costoInscripcion.Costo.toLocaleString()
        : 0
    )
  }, [costoInscripcion])

  // Costo Inscripcion
  useEffect(() => {
    setImporteColegiatura(
      costoColegiatura && costoColegiatura.hasOwnProperty("Costo")
        ? costoColegiatura.Costo.toLocaleString()
        : 0
    )
  }, [costoColegiatura])

  // #endregion

  // #region Functions
  //

  const handleImporteInscripcionChange = event => {
    const { value } = event.target

    // Filtrar solo números (incluyendo decimales y evitando múltiples puntos)
    const numericValue = value.replace(/[^0-9.]/g, "").replace(/^0+(?=\d)/, "")

    // Si hay más de un punto decimal, eliminar los extras
    const parts = numericValue.split(".")
    if (parts.length > 2) {
      numericValue = `${parts[0]}.${parts.slice(1).join("")}`
    }

    // Actualizar el valor en Formik
    formik.setFieldValue("Importe_Inscripcion", numericValue)
    setImporteInscripcion(numericValue.toLocaleString())
  }

  const handleImporteColegiaturaChange = event => {
    console.log("handleImporteColegiaturaChange")
    const { value } = event.target

    // Filtrar solo números (incluyendo decimales y evitando múltiples puntos)
    const numericValue = value.replace(/[^0-9.]/g, "").replace(/^0+(?=\d)/, "")

    // Si hay más de un punto decimal, eliminar los extras
    const parts = numericValue.split(".")
    if (parts.length > 2) {
      numericValue = `${parts[0]}.${parts.slice(1).join("")}`
    }

    // Actualizar el valor en Formik
    formik.setFieldValue("Importe_Colegiatura", numericValue)
    setImporteColegiatura(numericValue.toLocaleString())
  }

  const handleImporte = (id_Descuento, PrecioLista) => {
    // Busca el descuento en el arreglo que tenga el id_Descuento que nos pasan
    const descuentoSeleccionado = descuentosInscripcion.find(
      desc => desc.id_Descuento === id_Descuento
    )

    // Si no encuentra el descuento, retornamos el precio original
    if (!descuentoSeleccionado || !PrecioLista) {
      return PrecioLista
    }

    // Desestructuramos las propiedades del objeto de descuento
    const { Cantidad, Porcentaje } = descuentoSeleccionado
    console.log("Cantidad, Porcentaje:", Cantidad, Porcentaje)
    let importe_xPagar

    // Si el descuento es por cantidad fija (fija a aplicar)
    if (Cantidad > 0) {
      importe_xPagar = PrecioLista - Cantidad
    } else {
      // Si no tiene cantidad fija, se aplica un descuento porcentual
      // Nota: en este caso se retorna solo el monto del descuento
      importe_xPagar = PrecioLista - (Porcentaje * PrecioLista) / 100
    }

    return importe_xPagar
  }

  const handleDescuentoInscripcion = (e, value) => {
    const costo =
      costoInscripcion && costoInscripcion.hasOwnProperty("Costo")
        ? costoInscripcion.Costo
        : 0
    // Prende o apaga el control
    if (value == id_Descuento_Inscripcion_Personalizada) {
      setInputInscripcionDisabled(false)
      const input = document.getElementById("Importe_Inscripcion")
      if (input) {
        input.focus()
        input.select()
      }

      formik.setFieldValue("Importe_Inscripcion", costo)
      setImporteInscripcion(costo.toLocaleString())
    } else {
      const importe_xpagar = handleImporte(value, costo)
      formik.setFieldValue("Importe_Inscripcion", importe_xpagar)
      setImporteInscripcion(importe_xpagar.toLocaleString())
      setInputInscripcionDisabled(true)
    }

    // Siempre debe de llevar esta linea
    formik.setFieldValue("id_Descuento_Inscripcion", value)
  }

  const handleDescuentoColegiatura = (e, value) => {
    const costo =
      costoColegiatura && costoColegiatura.hasOwnProperty("Costo")
        ? costoColegiatura.Costo
        : 0
    if (value == id_Descuento_Colegiatura_Personalizada) {
      setInputColegiaturaDisabled(false)
      formik.setFieldValue("Importe_Colegiatura", costo)
      setImporteColegiatura(costo.toLocaleString())
    } else {
      const importe_xpagar = handleImporte(value, costo)
      formik.setFieldValue("Importe_Colegiatura", importe_xpagar)
      setImporteColegiatura(importe_xpagar.toLocaleString())
      setInputColegiaturaDisabled(true)
    }

    // Siempre debe de llevar esta linea
    formik.setFieldValue("id_Descuento_Colegiatura", value)
  }

  // #endregion

  return (
    <>
      {/* Sección de Cargos */}

      <Row>
        <h5 className="mt-4">Cargos</h5>
        <Col lg="6">
          {" "}
          <Card>
            <CardBody>
              <Row>
                <Row className="mb-0">
                  <Col sm="9">
                    <span>
                      <h4>
                        Inscripción - $
                        {costoInscripcion &&
                        costoInscripcion.hasOwnProperty("Costo")
                          ? costoInscripcion.Costo.toLocaleString()
                          : 0}
                      </h4>
                    </span>
                  </Col>
                  <Col sm="3">
                    <div className="d-flex justify-content-end mt-2">
                      <label>
                        <input
                          type="checkbox"
                          name="cargarInscripcion"
                          value="0"
                          checked={formik.values.cargarInscripcion}
                          onChange={() =>
                            formik.setFieldValue(
                              "cargarInscripcion",
                              !formik.values.cargarInscripcion
                            )
                          }
                        />{" "}
                        Cargar
                      </label>
                    </div>
                  </Col>
                </Row>

                <Row>
                  <Col sm="12">
                    <Row>
                      <div className="mb-3">
                        <FormikDatePicker
                          label="Inscripción a Partir de: "
                          name="Fecha_Inscripcion_Apartir"
                          placeholder="Fecha_Inscripcion_Apartir"
                          dateFormat="Y-m-d"
                          formik={formik}
                        />
                      </div>
                    </Row>
                  </Col>
                </Row>

                {/* Descuento */}
                <Row>
                  <Col sm="12">
                    <div className="mb-3">
                      <FormikSelect
                        label="Descuento"
                        name="id_Descuento_Inscripcion"
                        options={optionsDescuentosInscripciones || []}
                        formik={formik}
                        placeholder="Selecciona Descuento"
                        valuePlaceHolder={-1}
                        onChange={handleDescuentoInscripcion}
                      />
                    </div>
                  </Col>
                </Row>

                {/* Importe_Inscripcion */}
                <Row>
                  <Col sm="6">
                    <Row>
                      <div className="mb-3">
                        <FormikInput
                          label="Inscripción a Pagar"
                          name="Importe_Inscripcion"
                          value={`$${importeInscripcion}`}
                          placeholder="$"
                          formik={formik}
                          onChange={handleImporteInscripcionChange}
                          onFocus={event => event.target.select()}
                          disabled={inputInscripcionDisabled}
                        />
                      </div>
                    </Row>
                  </Col>
                </Row>
              </Row>
            </CardBody>
          </Card>
        </Col>

        {/* Colegiatura */}
        <Col sm="6">
          <Card>
            <CardBody>
              <Row>
                <Row className="mb-0">
                  <Col sm="9">
                    <span>
                      <h4>
                        Colegiatura - $
                        {costoColegiatura &&
                        costoColegiatura.hasOwnProperty("Costo")
                          ? costoColegiatura.Costo.toLocaleString()
                          : 0}
                      </h4>
                    </span>
                  </Col>
                  {/* Cargar checkbox */}
                  <Col sm="3">
                    <div className="d-flex justify-content-end mt-2">
                      <label>
                        <input
                          type="checkbox"
                          name="cargarColegiatura"
                          value="0"
                          checked={formik.values.cargarColegiatura}
                          onChange={() =>
                            formik.setFieldValue(
                              "cargarColegiatura",
                              !formik.values.cargarColegiatura
                            )
                          }
                        />{" "}
                        Cargar
                      </label>
                    </div>
                  </Col>
                </Row>

                <Row>
                  <Col sm="12">
                    <div className="mb-3">
                      <FormikSelect
                        label="Frecuencia de Colegiatura"
                        name="id_Frecuencia"
                        options={optionsFrecuenciaColegiatura || []}
                        formik={formik}
                        placeholder="Selecciona Frecuencia de Colegiatura"
                        valuePlaceHolder={-1}
                        disabled={true}
                      />
                    </div>
                  </Col>
                </Row>

                {/* Apartir */}
                <Row>
                  <Col sm="12">
                    <Row>
                      <div className="mb-3">
                        <FormikDatePicker
                          label="Colegiatura a Partir de:"
                          name="Fecha_Colegiatura_Apartir"
                          placeholder="Fecha_Colegiatura_Apartir"
                          dateFormat="Y-m-d"
                          formik={formik}
                        />
                      </div>
                    </Row>
                  </Col>
                </Row>

                {/* Descuento */}
                <Row>
                  <Col sm="12">
                    <FormikSelect
                      label="Descuento"
                      name="id_Descuento_Colegiatura"
                      options={optionsDescuentosColegiatura || []}
                      formik={formik}
                      placeholder="Selecciona Descuento"
                      valuePlaceHolder={-1}
                      onChange={handleDescuentoColegiatura}
                    />
                  </Col>
                </Row>

                {/* Colegiatura a Pagar */}
                <Row>
                  <Col sm="6">
                    <Row>
                      <div className="mb-3">
                        <FormikInput
                          label="Colegiatura a Pagar:"
                          name="Importe_Colegiatura"
                          value={`$${importeColegiatura}`}
                          placeholder="$"
                          formik={formik}
                          onChange={handleImporteColegiaturaChange}
                          onFocus={event => event.target.select()}
                          disabled={inputColegiaturaDisabled}
                        />
                      </div>
                    </Row>
                  </Col>
                </Row>
              </Row>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </>
  )
}

export default FormSectionCargos
